import { c as _c } from "react/compiler-runtime";
import { youthPolicyModalSafeLocalStorage } from '@module/lib/storage/storageImplementations';
import useModalStore from '@module/stores/useModalStore';
import TimeConstants from '@module/utils/item';
import { useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';
function usePushYouthPolicyModal() {
  const $ = _c(8);
  const {
    isLogin,
    userInfo
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore();
  let t0;
  if ($[0] !== isLogin || $[1] !== pushModal || $[2] !== userInfo?.idx) {
    t0 = () => {
      if (!isLogin || !userInfo?.idx) {
        return;
      }
      const youthPolicyModalStorageData = youthPolicyModalSafeLocalStorage.get()?.[userInfo?.idx || ""];
      const now = Date.now();
      const fifteenDaysAgo = now - TimeConstants.ONE_DAY * 15;
      const shouldShowModal = !youthPolicyModalStorageData?.checkedAt || youthPolicyModalStorageData.checkedAt < fifteenDaysAgo;
      if (shouldShowModal) {
        pushModal({
          type: "PLAY_YOUTH_POLICY_MODAL",
          id: "usePushYouthPolicyModal"
        });
      }
      const entries = youthPolicyModalSafeLocalStorage.get();
      if (!entries) {
        return;
      }
      for (const key in entries) {
        const record = entries[key];
        if (record && record.checkedAt < fifteenDaysAgo) {
          delete entries[key];
          youthPolicyModalSafeLocalStorage.set(entries);
        }
      }
    };
    $[0] = isLogin;
    $[1] = pushModal;
    $[2] = userInfo?.idx;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== isLogin || $[5] !== pushModal || $[6] !== userInfo) {
    t1 = [isLogin, pushModal, userInfo];
    $[4] = isLogin;
    $[5] = pushModal;
    $[6] = userInfo;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useEffect(t0, t1);
}
export default usePushYouthPolicyModal;